import {
  IconLayoutGrid,
  IconRobotFace,
  IconListDetails,
  IconUsers,
  IconUserCheck,
  IconMessage,
  IconMessageCircle,
  IconAt,
  IconSpeakerphone,
  IconChartArcs,
  IconReportAnalytics,
  IconPalette,
  IconLifebuoy,
  IconArrowsSort,
  IconRocket,
  IconCalendar,
  IconCalendarEvent,
  IconBrandLinkedin,
  IconMapPin,
  IconUpload,
  IconSend,
  IconClick,
  IconMail,
  IconBroadcast,
  IconDots,
  IconEye,
  IconPlus,
  IconSparkles,
  IconChevronLeft,
} from '@tabler/icons-react';

// Single place to map string keys (used across mock data) to icon components.
const ICONS = {
  dashboard: IconLayoutGrid,
  robot: IconRobotFace,
  list: IconListDetails,
  users: IconUsers,
  userCheck: IconUserCheck,
  template: IconMessage,
  reply: IconMessageCircle,
  at: IconAt,
  megaphone: IconSpeakerphone,
  progress: IconChartArcs,
  report: IconReportAnalytics,
  palette: IconPalette,
  support: IconLifebuoy,
  swap: IconArrowsSort,
  rocket: IconRocket,
  calendar: IconCalendar,
  calendarEvent: IconCalendarEvent,
  linkedin: IconBrandLinkedin,
  location: IconMapPin,
  upload: IconUpload,
  send: IconSend,
  click: IconClick,
  mail: IconMail,
  broadcast: IconBroadcast,
  dots: IconDots,
  eye: IconEye,
  plus: IconPlus,
  sparkles: IconSparkles,
  chevron: IconChevronLeft,
};

export function AppIcon({ name, size = 20, stroke = 1.8, ...props }) {
  const Cmp = ICONS[name] ?? IconLayoutGrid;
  return <Cmp size={size} stroke={stroke} {...props} />;
}

export default AppIcon;
